export enum InternalWorkoutReviewStatus {
    Pass = 'Pass',
    Fail = 'Fail',
    NeedReview = 'NeedReview',
}

export class InternalWorkoutReview {
    public reviewerName: string;
    public reviewStatus: InternalWorkoutReviewStatus = InternalWorkoutReviewStatus.NeedReview;
    public reviewComment: string;
    public stimulatingScore: string;
    public stimulatingComment: string;
    public expectationsScore: string;
    public expectationsComment: string;
    public resultsScore: string;
    public resultsComment: string;
    public disagreeComment: string;
}
